import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from 'react-select';

const LateReportWeekly = () => {
  // ✅ Get current week in ISO format (YYYY-Wxx)
  const getCurrentWeek = () => {
    const today = new Date();
    const onejan = new Date(today.getFullYear(), 0, 1);
    const days = Math.floor((today - onejan) / (24 * 60 * 60 * 1000));
    const week = Math.ceil((days + onejan.getDay() + 1) / 7);
    return `${today.getFullYear()}-W${String(week).padStart(2, "0")}`;
  };

  const [filters, setFilters] = useState({
    start_date: getCurrentWeek(),
    dept_id: "0",
    action_type: "Fetch",
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch Departments
  const fetchDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/showdepartment", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      const deptData =
        res.data.departments || res.data.data || (Array.isArray(res.data) ? res.data : []);
      setDepartments(deptData);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ✅ Fetch Weekly Report
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        API_BASE_URL + "/weekly_late_report",
        {
          start_date: filters.start_date,
          dept_id: filters.dept_id,
          action_type: filters.action_type,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );
      setRecords(res.data.records || []);
      setCurrentPage(1);
      toast.success("Weekly late report loaded!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error fetching weekly late report");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Pagination + Filter
  const filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department}${item.total_late_hours}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">
        <ToastContainer />

        {/* Header Navigation */}
        <div className="mb-3 d-flex flex-wrap gap-2">
          <a href="/Late-report" className="btn btn-outline-secondary btn-sm">
            Day Wise Late Report
          </a>
          <a href="/weeklylate-report" className="btn btn-info btn-sm">
            Weekly Late Report
          </a>
          <a href="/monthlylate-report" className="btn btn-outline-secondary btn-sm">
            Month Wise Late Report
          </a>
        </div>

        {/* Filter Form */}
        <div className="card shadow-sm mb-4">
          <div className="card-header">
            <span className="card-header-title me-2">Weekly Late Report Filter</span>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                <div className="col-md-3">
                  <label htmlFor="start_date">Select Week</label>
                  <input
                    type="week"
                    className="form-control"
                    name="start_date"
                    value={filters.start_date}
                    onChange={handleInput}
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label htmlFor="dept_id">Department</label>
                   <Select
    name="dept_id"
    
    value={
      departments
        .map((dept) => ({
          value: dept.department_id || dept.id,
          label: dept.department_name,
        }))
        .find((d) => d.value === filters.dept_id) || null
    }
    onChange={(selected) =>
      handleInput({
        target: {
          name: "dept_id",
          value: selected ? selected.value : "0", // same as All Department
        },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id || dept.id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All Department"
    className="basic-single"
  />
                </div>

                <div className="col-md-2">
                  <label htmlFor="action_type">Action</label>
                  <select
                    className="form-control"
                    name="action_type"
                    value={filters.action_type}
                    onChange={handleInput}
                  >
                    <option value="Fetch">Show</option>
                  </select>
                </div>

                <div className="col-md-2">
                  <button type="submit" className="btn btn-primary w-100 mt-2">
                    Get
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Table */}
        <div className="card">
          <div className="card-header">
            <h6 className="text-danger">Weekly Late Report Summary</h6>
          </div>

          <div className="card-body">
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div className="d-flex align-items-center gap-2">
                <DownloadButtons data={filteredItems} filename="Weekly_Late_Report" />
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>

              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search..."
                style={{ width: "200px" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead style={{ backgroundColor: "#7d858369" }}>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Department</th>
                      <th>Total Late Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.department}</td>
                          <td>{row.total_late_hours}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-danger fw-bold">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LateReportWeekly;
